import React from 'react';
import './ContactSection.css';


const ContactSection = () => (
  <section className="contact-section">
    <div className="contact-text-container">
      <h2 className="contact-title">LASS UNS MITEINANDER SPRECHEN</h2>
      <h2>Von emotionaler Überforderung hin zu innerer Stärke und Klarheit.</h2>
      <ul className="contact-list">
        <li>Effektive NLP- und Hypnose-Techniken für nachhaltige Veränderung</li>
        <li>Aktivierung deiner inneren Heilkräfte und Selbstermächtigung</li>
        <li>Individuelle Strategien für eine erfolgreiche Umsetzung im Alltag</li>
      </ul>
      <a href="https://calendly.com/ckorner/kennenlerngesprach" class="contact-button">Kostenloses Erstgespräch vereinbaren</a>


      {/* Text vor der Textbox */}
      <p className="message-title">Du hast noch Fragen?</p>

      {/* Textbox und Button */}
      <div className="message-box-container">
      <a href="mailto:ckorner32@gmail.com" className="send-button">
        Sende mir eine Nachricht
      </a>
      </div>
    </div>
    <div className="contact-image-container">
      <img src={require('../assets/images/chiaraTr3.png')} alt="Telefon" className="contact-image" />
    </div>
  </section>
);

export default ContactSection;
